<div class="trucking-component">
  <div class="heading flex flex-row justify-between">
    <h2>Trailers</h2>
    <div class="self-center">
      <div class="search-bar-container">
        <select [(ngModel)]="selectedCategory" class="category-select">
          <option value="trailerName">Trailer Name</option>
          <option value="trailerTypeName">Trailer Type</option>
          <option value="subcarrierName">Subcarrier Name</option>
        </select>
        <input
          type="text"
          class="search-bar"
          placeholder="Search..."
          [(ngModel)]="searchQuery"
          (input)="filterTrailers()"
        />
        <button *ngIf="searchQuery" class="clear-button self-center" (click)="clearSearch()">Clear</button>
      </div>
    </div>
    <div class="self-center">
      <button
        *ngIf="canManageTrailerManagement.value"
        class="h-auto"
        mat-flat-button
        color="primary"
        (click)="createEdit$$.next({})"
      >
        ADD NEW
      </button>
    </div>
  </div>

  <div>
    <div class="grid grid-cols-6 gap-1 table-header items-center">
      <div class="clickable-header" (click)="sortTrailers('trailerName')">
        Trailer Number {{ sortIcons.trailerName }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('trailerTypeName')">
        Trailer Type {{ sortIcons.trailerTypeName }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('trailerRegion')">
        Assigned Region {{ sortIcons.trailerRegion }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('trailerStatus')">
        Trailer Status {{ sortIcons.trailerStatus }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('subcarrierName')">
        Assigned Subcarrier {{ sortIcons.subcarrierName }}
      </div>
      <div class="clickable-header" (click)="sortTrailers('createdTimestamp')">
        Created Date {{ sortIcons.createdTimestamp }}
      </div>
    </div>

    <div class="table-body">
      <div
        *ngFor="let trailer of sortedTrailers; trackBy: trailers | trackByKey: 'trailerId'"
        class="grid grid-cols-6 gap-1 items-center row cursor-pointer"
      >
        <div class="cell">{{ trailer.trailerName }}</div>
        <div class="cell">{{ trailer.trailerTypeName | dashIfNothing }}</div>
        <div class="cell">{{ trailer.trailerRegion | dashIfNothing }}</div>
        <div class="cell">{{ prettyStatus(trailer.trailerStatus) }}</div>
        <div class="cell">{{ trailer.subcarrierName | dashIfNothing }}</div>
        <div *ngIf="!canManageTrailerManagement.value" class="cell">
          {{ trailer.createdTimestamp | date: 'H:mm LLL dd' }}
        </div>
        <div *ngIf="canManageTrailerManagement.value" class="cell flex justify-between">
          <div>
            {{ trailer.createdTimestamp | date: 'H:mm LLL dd' }}
          </div>
          <div class="flex">
            <div (click)="editTrailer(trailer)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#1f7a8c"
              >
                <path
                  d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"
                />
              </svg>
            </div>
            <div (click)="promptDeleteTrailer(trailer)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#1f7a8c"
              >
                <path
                  d="m376-300 104-104 104 104 56-56-104-104 104-104-56-56-104 104-104-104-56 56 104 104-104 104 56 56Zm-96 180q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520Zm-400 0v520-520Z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="createEdit$$ | async as openCreate">
  <div class="back-layer-component" (click)="closeNewTrailerForm()"></div>
  <sa-trailer-management-create-edit
    [editTrailer]="openCreate"
    [trailerTypes]="trailerTypes"
    [subcarriers]="subcarriers"
    (onCloseClicked)="closeNewTrailerForm()"
  >
  </sa-trailer-management-create-edit>
</ng-container>
